<template>
  <div style="padding: 0 10px">
    <Form layout="code, date, business, warehouse,systemSource,inboundCode" @search="search"></Form>
    <WmsTable :isPagination="query" :columns="columns" :dataSource="dataSource" @pageChange="pageChangeCall">
      <div slot="errorImg" slot-scope="{text, record}" style="position: relative;">
        <!-- <ImgPreviews :images="text" v-if="text"></ImgPreviews> -->
        <el-image
          :src="text?.[0]"
          style="width:80px;height: 80px;"
          :preview-src-list="text"
          alt="图片"
          class="previewsImage-tag" v-if="text?.[0]">
        </el-image>
        <span v-else>-</span>
        <div class="tag-side-content">
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('outside')" class="tag-item">表面</div>
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('inside')" class="tag-item">内里</div>
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('normal')" class="tag-item">正品</div>
          <div v-if="record.imgDTOList?.[0]?.tags?.includes('defective')" class="tag-item">次品</div>
        </div>
      </div>
      <div slot="action" slot-scope="record">
        <a @click="print(record)">打印</a>
        <a @click="changePic(record)" style="margin-left:10px" :disabled="record.record.wareStatus == 1 || record.record.serviceStatus == 1">修改图片</a>
      </div>
    </WmsTable>
    <changePic ref="changePic" @update="getDataSource"></changePic>
  </div>
</template>

<script>
import Form from "@/views/abnormal/components/form";
import WmsTable from "@/components/WmsTable";
import { columns } from "@/views/abnormal/defective/columns";
import { abnormalPage } from "@/apis/abnormal";
import { templatePrintByPkg } from "@/utils/print";
import ImgPreviews from "@/components/ImgPreviews"
import changePic from "../components/changePic.vue";

export default {
  name: "abnormal_defectiveProducts",
  components: { Form, WmsTable, ImgPreviews,changePic },
  props: {},
  data() {
    return {
      columns,
      dataSource: [],
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },

  created() { },

  methods: {
    search(formInline) {
      this.formInline = formInline;
      this.query.current = 1
      this.getDataSource();
    },
    print(row) {
      this.$wmsPrint.print().templatePrintByPkg([row.record])
    },
    getDataSource() {
      let params = this.formInline;
      params.pageSize = this.query.pageSize;
      params.pageNum = this.query.current;
      params.pkgTypes = [2];
      abnormalPage(params).then(({ code, data }) => {
        if (code === 0) {
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getDataSource();
    },
    changePic(r){
      this.$refs.changePic.open(r.record)
    }
  },
};
</script>

<style scoped lang="less">
</style>
